import integrationPaymentTypes from '@helpers/labels/integrationPaymentTypes'
import {getSavedValue} from '@hooks/useSessionStorageState'

import getDefaultOptions from './getDefaultOptions'

export default function getOptions({preferences}) {
  if (preferences.isIncognitoSession) {
    let incognitoSessionPaymentType
    if (preferences.incognitoSessionPreferences.incognitoSessionPaymentType)
      incognitoSessionPaymentType =
        preferences.incognitoSessionPreferences.incognitoSessionPaymentType
    return {
      options: {
        ...getDefaultOptions(),
        ...preferences,
        paymentType: incognitoSessionPaymentType
      }
    }
  }

  const {
    cart,
    deliveryType,
    channel,
    address,
    time,
    paymentType,
    cashAmount,
    otherPaymentType,
    menuId,
    store,
    cardId,
    couponCode,
    tableName,
    orderParams,
    billingParams,
    sessionEmail,
    sessionPhone,
    chatCommerceType,
    gift
  } = preferences

  const {calculatedTipAmount, itemsPrice, amountToPay} = cart

  if (!preferences.store) {
    if (deliveryType === 'delivery') {
      return {missingFields: 'Por favor indica tu dirección de despacho'}
    } else {
      return {missingFields: 'Selecciona un local'}
    }
  }

  // if (deliveryType === 'delivery' && address) {
  //   if (!address.addressLine2 && !address.acceptsNoLine2) {
  //     return {
  //       missingFields:
  //         'Debes indicar si tu dirección de entrega es una casa o el número de departamento y guardar'
  //     }
  //   }
  // }

  const payingCashOnDelivery = paymentType === 'cash' && deliveryType === 'delivery'
  const options = {
    orderParams,
    billing: billingParams,
    addressId: deliveryType === 'delivery' ? (address ? address._id : null) : null,
    channel,
    tipAmount: integrationPaymentTypes.includes(paymentType) ? calculatedTipAmount : null,
    itemsPrice,
    amountToPay,
    storeId: store._id,
    menuId,
    deliveryType,
    dropOffType: preferences.dropOffType,
    time,
    paymentType,
    couponCode,
    tableName,
    cashAmount: payingCashOnDelivery ? cashAmount : null,
    cardId: cardId,
    otherPaymentType:
      paymentType === 'other' && deliveryType === 'delivery' ? otherPaymentType : null,
    skipPhoneValidation: deliveryType === 'serve',
    sessionEmail,
    sessionPhone,
    chatCommerceType,
    gift,
    source: getSavedValue('orderSource', 'web') || 'web'
  }

  return {options}
}
